module.exports = __webpack_public_path__ + "img/5.4066b07c.png";